import { QueryClient } from "@tanstack/react-query";

import {
  BidQuery,
  LeadQuery,
  RefreshBuyerActivitySummaryMutation,
} from "lib/generated/app-service-gql/graphql";
import { BuyerActivityObjectType } from "lib/types/graphQLEnums";

type BuyerActivityUpdate = RefreshBuyerActivitySummaryMutation["refreshBuyerActivitySummary"];

export async function updateBuyerActivityCache(
  queryClient: QueryClient,
  objectId: string,
  objectType: BuyerActivityObjectType,
  buyerActivityData: BuyerActivityUpdate,
) {
  switch (objectType) {
    case "lead":
      queryClient.setQueryData<LeadQuery>(["lead", objectId], (oldData) => {
        if (!oldData) {
          return undefined;
        }
        return {
          ...oldData,
          lead: {
            ...oldData.lead,
            buyerActivity: {
              ...oldData.lead.buyerActivity,
              ...buyerActivityData,
            },
          },
        };
      });
      break;
    case "bid":
      queryClient.setQueryData<BidQuery>(["bid", objectId], (oldData) => {
        if (!oldData) {
          return undefined;
        }
        return {
          ...oldData,
          bid: {
            ...oldData.bid,
            buyerActivity: {
              ...oldData.bid.buyerActivity,
              ...buyerActivityData,
            },
          },
        };
      });
      break;
    default:
      throw new Error(
        `Unable to update buyer activity cache, unsupported object type: ${objectType}`,
      );
  }
}
